import { useState, useCallback } from "react";
import { toast } from "sonner";
import { submitContact, formatApiError } from "../lib/api";

export const PROJECT_TYPES = [
  "Lumber Package",
  "Structural Steel",
  "Engineered Wood / Trusses",
  "Full Material Takeoff",
  "Fasteners & Hardware",
  "Job-Site Delivery",
  "Combined / Multiple",
];

const blankForm = () => ({
  name: "",
  company: "",
  email: "",
  phone: "",
  project_type: PROJECT_TYPES[0],
  project_date: "",
  project_location: "",
  message: "",
});

const validate = (form) => {
  if (!form.name.trim()) return "Please enter your name.";
  if (!form.email.trim()) return "Please enter your email.";
  if (!form.message.trim()) return "Please add a message.";
  return null;
};

/**
 * Encapsulates the contact form's state, validation, and submission lifecycle.
 * Returns props ready to wire into a presentational form component.
 */
export const useContactForm = () => {
  const [form, setForm] = useState(blankForm);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const updateField = useCallback(
    (field) => (e) => setForm((s) => ({ ...s, [field]: e.target.value })),
    []
  );

  const reset = useCallback(() => {
    setForm(blankForm());
    setSubmitted(false);
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (submitting) return;

      const err = validate(form);
      if (err) {
        toast.error(err);
        return;
      }

      setSubmitting(true);
      try {
        await submitContact(form);
        setSubmitted(true);
        toast.success("Quote request received - we'll be in touch shortly.");
        setForm(blankForm());
      } catch (err) {
        toast.error(formatApiError(err) || "Something went wrong. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
    [form, submitting]
  );

  return { form, submitting, submitted, updateField, onSubmit, reset };
};
